import { inject, Injectable } from '@angular/core';
import { combineLatest, map, Observable } from 'rxjs';

import { ShopStoreSelector } from '@common/selectors/shop.selector';

import {
  ShopHeroImageBlockDataSource,
  ShopHeroImageBlockViewModel,
} from './shop-hero-image-block-view-model';

@Injectable()
export class ShopHeroImageBlockStoreDataSource implements ShopHeroImageBlockDataSource {
  private readonly shopSelector = inject(ShopStoreSelector);

  readonly vm$: Observable<ShopHeroImageBlockViewModel> = combineLatest({
    shop: this.shopSelector.selectActive$,
    isShopLoading: this.shopSelector.selectIsLoading$,
  }).pipe(
    map(({ shop, isShopLoading }) => ({
      shop: shop ?? null,
      isShopLoading: !!isShopLoading,
    })),
  );
}
